import React from "react";
import "../mycontent.css";
import {
  Form,
  Input,
  Button,
  Card,
  Popconfirm,
  Table,
  Drawer,
  Tooltip,
} from "antd";
import { connect } from "react-redux";

import {
  fetchContentUnit,
  createContentUnit,
  updateContentUnit,
  emptyContentUnit,
} from "../../../../store/actions/selfContentUnitAction";
import { MY_CONTENT_BASE_URL } from "../../../../constants/LookupConst";
import CircularProgress from "../../../../components/CircularProgress";
import { toast } from "react-toastify";
// import moment from "moment";
import selfContentUnitService from "../../../../services/selfContentUnit/selfContentUnitService";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

class SelfTextbook extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChapterListVisible: false,
      isAddChapterVisible: false,
    };
  }
  formRef = React.createRef();

  async componentDidMount() {
    const {
      match: { params },
      fetchContentUnit,
    } = this.props;
    if (params.id) {
      await fetchContentUnit("textbook", params.id);
    }

    this.setState({
      isChapterListVisible: !!params.id,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedContentUnit } = this.props;
    if (
      prevProps.selectedContentUnit &&
      prevProps.selectedContentUnit._id !== selectedContentUnit._id
    ) {
      let chapters = selectedContentUnit.chapters;
      if (chapters && chapters.length > 0) {
        chapters = chapters.map((ele, index) => ({
          ...ele,
          index: index + 1,
        }));
      }
      this.setState({
        chapters,
      });
    }
  }

  async componentWillUnmount() {
    this.props.emptyContentUnit();
  }

  // onCategoryChange = (data) => {
  //   this.setState({ category: data });
  // };
  // onMainSubjectNameChange = (data) => {
  //   this.setState({ mainsubjectname: data });
  // };
  // onSubSubjectNameChange = (data) => {
  //   this.setState({ subsubjectname: data });
  // };

  onDelete = async (id) => {
    let { chapters } = this.state;
    const { params } = this.props.match;
    chapters = chapters.filter((ele) => ele._id !== id);
    await selfContentUnitService.deleteChapter(params.id, id).then((res) => {
      this.setState({
        chapters: chapters.map((ele, index) => ({
          ...ele,
          index: index + 1,
        })),
      });
      toast.success(res);
    });
  };

  ChapterColumns = () => [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Chapter #",
      dataIndex: "chapternumber",
      key: "chapternumber",
    },
    {
      title: "Action",
      dataIndex: "Action",
      render: (_, record) => {
        return (
          <span>
            <a
              href="javascript:void(0);"
              onClick={() => this.edit(record)}
              style={{ marginRight: 8 }}
            >
              Edit
            </a>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => this.onDelete(record._id)}
            >
              <a href="!#">Delete</a>
            </Popconfirm>
          </span>
        );
      },
    },
  ];

  edit = (record) => {
    this.setState({
      isAddChapterVisible: true,
      selectedChapterData: { ...record },
    });
  };

  openDrawer = async () => {
    this.setState({
      isAddChapterVisible: true,
      selectedChapterData: {},
    });
  };

  CreateChapters = (data = {}) => {
    return (
      <div style={{ paddingTop: "50px" }}>
        <Form
          ref={this.chapterFormRef}
          {...formItemLayout}
          name="register"
          onFinish={this.onChapterAddFinish}
          scrollToFirstError
        >
          {/* <InputSelectAdd
              category={"mainsubjectname"}
              placeholder={`Please assign main subject name`}
              onChange={this.onMainSubjectNameChange}
              parenttype={"reading"}
              name={"mainsubjectname"}
              initialValue={this.state.mainsubjectname}
              label={"Main Subject Name"}
            />
            <InputSelectAdd
              category={"subsubjectname"}
              placeholder={`Please assign sub subject name`}
              onChange={this.onSubSubjectNameChange}
              parenttype={"reading"}
              name={"subsubjectname"}
              initialValue={this.state.subsubjectname}
              label={"Sub Subject Name"}
            /> */}
          <Form.Item
            name="name"
            label="Name"
            initialValue={data.name}
            rules={[
              {
                type: "string",
                message: "The input is not valid chapter name",
              },
              {
                required: true,
                message: "Please input chapter name",
              },
            ]}
          >
            <Input placeholder="Please enter chapter name" value={data.name} />
          </Form.Item>
          <Form.Item
            name="chapternumber"
            label="Chapter #"
            initialValue={data.chapternumber}
            rules={[
              {
                type: "string",
                message: "The input is not valid chapter number",
              },
              {
                required: true,
                message: "Please input chapter number",
              },
            ]}
          >
            <Input
              placeholder="Please enter a chapter number"
              value={data.chapternumber}
            />
          </Form.Item>

          <Form.Item {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              {!!data._id ? "Update" : "Create"}
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  };

  onChapterAddFinish = async (values) => {
    const {
      match: { params },
    } = this.props;
    const { selectedChapterData } = this.state;

    if (!(selectedChapterData && selectedChapterData._id)) {
      await selfContentUnitService.addChapter(
        { ...values },
        params.id,
        async (res) => {
          console.log("p-----1-", res);
          if (res.status === 200) {
            toast.success(res.data.msg);
            await this.refreshAndCloseDrawer(params.id);
            // toast.success(res.message);
          } else {
            toast.error(res.message);
          }
        }
      );
    } else {
      await selfContentUnitService.updateChapter(
        { ...values, courseplanid: params.id },
        params.id,
        selectedChapterData._id,
        async (res) => {
          if (res.status === 200) {
            toast.success(res.data.msg);
            await this.refreshAndCloseDrawer(params.id);
            // toast.success(res.message);
          } else {
            toast.error(res.message);
          }
        }
      );
    }
  };

  refreshAndCloseDrawer = async (textbookid) => {
    const { params } = this.props.match;
    let contentunit = await selfContentUnitService.fetchSelfContentUnit(
      "textbook,",
      params.id
    );
    let chapters = contentunit.chapters;
    if (chapters && chapters.length > 0) {
      chapters = chapters.map((ele, index) => ({
        ...ele,
        index: index + 1,
      }));
    }
    this.setState({
      isAddChapterVisible: false,
      chapters,
    });
  };

  render() {
    const onFinish = async (values) => {
      const { history } = this.props;
      let result = {};
      // const { category, mainsubjectname, subsubjectname } = this.state;
      if (!params.id) {
        result = await this.props.createContentUnit(
          "textbook",
          {
            ...values,
            // category, mainsubjectname, subsubjectname
          },
          (res) => {
            if (res.success) {
              toast.success(res.message);
            } else {
              toast.error(res.message);
            }
          }
        );
      } else {
        result = await this.props.updateContentUnit(
          "textbook",
          {
            ...values,
            // category, mainsubjectname, subsubjectname
          },
          params.id,
          (res) => {
            if (res.success) {
              toast.success(res.message);
            } else {
              toast.error(res.message);
            }
          }
        );
      }
      if (result && result.contentunit && result.contentunit._id)
        history.push(
          `${MY_CONTENT_BASE_URL}/textbook/${result.contentunit._id}`
        );
    };

    const { chapters } = this.state;

    const {
      // lookupTextbookYears,
      // location: { search },
      match: { params },
      selectedContentUnit,
      loading,
      // countries,
      // professors
    } = this.props;
    const { isChapterListVisible, isAddChapterVisible } = this.state;
    const data = selectedContentUnit;
    if (!(data && data._id) && params.id) {
      return (
        <div className="gx-loader-view">
          <CircularProgress />
        </div>
      );
    }
    return (
      <Card className="gx-card blast-mc" title="Create Textbook">
        {!loading ? (
          <Form
            ref={this.formRef}
            {...formItemLayout}
            name="register"
            onFinish={onFinish}
            scrollToFirstError
          >
            <Form.Item
              name="isbn"
              label="Book ISBN"
              initialValue={data.isbn}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid isbn",
                },
                {
                  required: true,
                  message: "Please input isbn",
                },
              ]}
            >
              <Input placeholder="Please enter a isbn" value={data.isbn} />
            </Form.Item>
            <Form.Item
              name="unitname"
              label="Book Name"
              initialValue={data.unitname}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid name",
                },
                {
                  required: true,
                  message: "Please input book name",
                },
              ]}
            >
              <Input placeholder="Please enter a name" value={data.unitname} />
            </Form.Item>
            <Form.Item
              name="author"
              label="Author"
              initialValue={data.author}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid author",
                },
                // {
                //   required: true,
                //   message: "Please input author",
                // },
              ]}
            >
              <Input placeholder="Please enter a author" value={data.author} />
            </Form.Item>
            {/* <InputSelectAdd
              category={"category"}
              placeholder={`Please assign a category`}
              onChange={this.onCategoryChange}
              parenttype={"otherstuff"}
              name={"category"}
              initialValue={this.state.category}
              label={"Category"}
            />
            <InputSelectAdd
              category={"mainsubjectname"}
              placeholder={`Please assign main subject name`}
              onChange={this.onMainSubjectNameChange}
              parenttype={"otherstuff"}
              name={"mainsubjectname"}
              initialValue={this.state.mainsubjectname}
              label={"Main Subject Name"}
            />
            <InputSelectAdd
              category={"subsubjectname"}
              placeholder={`Please assign sub subject name`}
              onChange={this.onSubSubjectNameChange}
              parenttype={"otherstuff"}
              name={"subsubjectname"}
              initialValue={this.state.subsubjectname}
              label={"Sub Subject Name"}
            /> */}
            {/* <Form.Item
            name="startdate"
            label="Start date"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please select test date!",
            //   },
            // ]}
            initialValue={moment()}
          >
            <DatePicker
              placeholder="Please enter a start date"
              // value={scheduledAt}
              format="MM/DD/YYYY"
              className="gx-w-100"
              // onChange={this.onDateChange}
            />
          </Form.Item>
          <Form.Item
            name="enddate"
            label="End date"
            // rules={[
            //   {
            //     required: true,
            //     message: "Please select test date!",
            //   },
            // ]}
            // initialValue={moment()}
          >
            <DatePicker
              placeholder="Please enter a end date"
              // value={scheduledAt}
              format="MM/DD/YYYY"
              className="gx-w-100"
              // onChange={this.onDateChange}
            />
          </Form.Item> */}
            {/* <Form.Item
              name="additionalinformation"
              label="Additional Information"
              initialValue={data.additionalinformation}
              rules={[
                {
                  type: "string",
                  message: "The input is not valid additionalinformation",
                },
                // {
                //   required: true,
                //   message: "Please input additionalinformation",
                // },
              ]}
            >
              <Input
                placeholder="Please enter a additionalinformation"
                value={data.additionalinformation}
              />
            </Form.Item> */}
            <Form.Item {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit">
                {!!params.id ? "Update" : "Create"}
              </Button>
              <Tooltip
                placement="top"
                title={`${
                  !!params.id ? "Add" : "Please click the create button to add"
                } chapters `}
              >
                <Button
                  disabled={!params.id}
                  type="primary"
                  onClick={() => this.openDrawer()}
                >
                  Add Chapters
                </Button>
              </Tooltip>
            </Form.Item>
          </Form>
        ) : (
          <div className="gx-loader-view">
            <CircularProgress />
          </div>
        )}
        {isChapterListVisible && (
          <Table
            className="gx-table-responsive"
            // loading={notesLoading}
            columns={this.ChapterColumns()}
            dataSource={chapters}
            pagination={{ pageSize: 8 }}
          ></Table>
        )}
        <Drawer
          title={`${
            !(
              this.state.selectedChapterData &&
              this.state.selectedChapterData._id
            )
              ? "Create"
              : "Update"
          } Chapter`}
          placement="right"
          style={{ width: "800px !important" }}
          width={800}
          closable={false}
          onClose={() => this.setState({ isAddChapterVisible: false })}
          visible={isAddChapterVisible}
          className="selfstudyplan"
        >
          {isAddChapterVisible &&
            this.CreateChapters(this.state.selectedChapterData)}
        </Drawer>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedContentUnit: state.selfcontentunits.selectedContentUnit,
  loading: state.selfcontentunits.loading,
});

const mapDispatchToProps = {
  createContentUnit,
  fetchContentUnit,
  updateContentUnit,
  emptyContentUnit,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfTextbook);
